module.exports = __webpack_public_path__ + "20240429_141835/img/cm-logo.bd93923.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cm-logo.png
// module id = KTm/
// module chunks = 1